import React from 'react';
import PropTypes from 'prop-types';
import { Calendar } from 'common/components';

const CalendarWithLabel = ({ label, onChangeFunc, onChangeParams, defaultStartDate, defaultEndDate }) => (
  <div className="CalendarWithLabel">
    <span className="CalendarWithLabel__label">{label}</span>
    <Calendar
      onChangeFunc={onChangeFunc}
      onChangeParams={onChangeParams}
      defaultStartDate={defaultStartDate}
      defaultEndDate={defaultEndDate}
    />
    <style jsx>{`
      .CalendarWithLabel {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: auto;
      }
      .CalendarWithLabel__label {
        white-space: nowrap;
        color: #0f0f0f;
        font-size: 14px;
        line-height: 40px;
        margin-bottom: 10px;
      }
    `}</style>
  </div>
);

CalendarWithLabel.propTypes = {
  label: PropTypes.string.isRequired,
  onChangeFunc: PropTypes.func,
  onChangeParams: PropTypes.object,
  defaultStartDate: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  defaultEndDate: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
};

CalendarWithLabel.defaultProps = {
  onChangeFunc: null,
  onChangeParams: {},
  defaultStartDate: null,
  defaultEndDate: null,
};

export default CalendarWithLabel;
export { CalendarWithLabel };
